import {NgModule} from '@angular/core';
import {L10nModule} from '../translate';
import {CopyTooltipBalloonComponent} from './copy-tooltip-balloon.component';
import {CopyTooltipDirective} from './copy-tooltip.directive';

@NgModule({
    declarations: [
        CopyTooltipBalloonComponent,
        CopyTooltipDirective
    ],
    imports:      [
        L10nModule
    ],
    exports:      [
        CopyTooltipDirective
    ]
})
export class CopyTooltipModule {}
